const seriesLabelConfig = {
    normal: {
        show: true,
        color:'#00578F',
        position: 'right',
        formatter: function (a) {
            var result = [], counter = 0;
            var num_array = a.data.toFixed(2).split('.');
            var num = num_array[0];
            for (var i = num.length - 1; i >= 0; i--) {
                counter++;
                result.unshift(num[i]);
                if (!(counter % 3) && i != 0) { result.unshift(','); }
            }
            if (num == 0) {
                return '0';
            }
            return result.join('');
        },
    }
};


export default {
    seriesLabelConfig,
}